import React from 'react'
import { styled } from 'linaria/react'

import { theme } from '../../Theme'
import { CheckCircle, WarningCircle } from 'iconoir-react'

const ResponseViewerContainer = styled.div`
   display: flex;
   flex-direction: column;
   border-radius: 8px;
   border-color: ${props => (props.isError ? "#ffc1c1" : "#aedfae" )}; 
   border-width: 2px; 
   border-style: solid; 
   padding: 1rem 1rem 1rem 1rem;
   background-color: ${props => (props?.isError ? '#ffefef' : '#f8fdf7')};
   /* ${theme.above.sm} {
      padding: 1rem 1rem 1rem 1rem;
   } */

   .response-header {
      display: flex;
      & > p {
         font-weight: 700;
      }

      & > :first-of-type {
         margin-right: 0.5rem;
      }
   }
   .response-message {
      line-height: normal;
   }
`

const ResponseViewer = ({ title, message, isError, className }) => {
   if (typeof isError !== 'boolean') {
      return null
   }

   return (
      <ResponseViewerContainer isError={isError} className={`${className}`}>
         <div className="response-header">
            {isError ? <WarningCircle /> : <CheckCircle />}
            {title && <p> {title}</p>}
         </div>
         <div className="response-message">
            <span>{message}</span>
         </div>
      </ResponseViewerContainer>
   )
}

export default ResponseViewer